import "./FitLevelLegendElement.less";
import * as React from "react";
import { AnalysisTileEnum, FitLevelEnum } from "@atman/business";

export interface IFitLevelLegendElementProps {
    fitLevel: FitLevelEnum;
    count: number;
    active: boolean;
    onClick: (fitLevel: FitLevelEnum | "showAll") => void;
    tile: AnalysisTileEnum;
}

const FitLevelLegendElement: React.FC<IFitLevelLegendElementProps> = (props) => {
    const { fitLevel, count, onClick, active, tile } = props;

    const onClickImpl = () => onClick(!active ? fitLevel : "showAll");
    const competenciesLabelMapping: Dictionary<FitLevelEnum, string> = {
        [FitLevelEnum.VeryGood]: "naturalTalent",
        [FitLevelEnum.GoodFit]: "good",
        [FitLevelEnum.BeVigilent]: "lessNatural",
    };

    const fitLevelEnumString = React.useMemo(() => {
        return FitLevelEnum[fitLevel];
    }, [fitLevel]);

    const fitLevelLabel = React.useMemo(() => {
        if (tile === AnalysisTileEnum.Competencies) {
            return competenciesLabelMapping[fitLevel];
        }

        return fitLevelEnumString;
    }, [tile, fitLevel]);

    let classes: string = `FitLevelLegendElement ${fitLevelEnumString}`;

    if (active) {
        classes += " active";
    }

    if (tile === AnalysisTileEnum.Competencies) {
        classes += " competencies";
    }

    return (
        <div className={classes} onClick={onClickImpl}>
            <div className="count-header">
                <div className="indicator"></div>
                <span className="count-label">{`global.fitLevels.${fitLevelLabel.toCamel()}`.localize()}</span>
            </div>
            <span className="count">{count}</span>
        </div>
    );
};

export default FitLevelLegendElement;
